import { motion } from 'framer-motion'
import type { SlideProps } from '@/components/SlideWizard'
import { useSlideCopy } from '@/lib/i18n'
import { copy } from './Slide6Tips.copy'

const ease = [0.16, 1, 0.3, 1] as const

export default function Slide6Tips(_props: SlideProps) {
  const c = useSlideCopy(copy)
  const TIPS = [
    { label: c.tip1Label, body: c.tip1Body },
    { label: c.tip2Label, body: c.tip2Body },
    { label: c.tip3Label, body: c.tip3Body },
  ]

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center px-4 max-w-4xl mx-auto">
      <div className="w-full max-w-2xl">
        <motion.h2
          initial={{ opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.15, ease }}
          className="mt-4 text-4xl sm:text-6xl font-semibold text-slate-900 tracking-tight leading-[1.05] text-start"
        >
          {c.title}
        </motion.h2>
      </div>

      <ul className="mt-8 w-full max-w-2xl space-y-5 text-start list-disc ps-5">
        {TIPS.map((tip, i) => (
          <motion.li
            key={i}
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.45, delay: 0.35 + i * 0.1, ease }}
          >
            <p className="text-lg sm:text-xl font-semibold text-slate-900 leading-snug">
              {tip.label}
            </p>
            <p className="mt-1.5 text-base sm:text-lg text-slate-500 leading-relaxed">
              {tip.body}
            </p>
          </motion.li>
        ))}
      </ul>
    </div>
  )
}
